import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    // tab顯示當次選擇變更的流程
    serviceList: [],
    // 保單下所有流程 or 獨立流程
    transactionItems: [],
    // 變更資料
    changeItemsResult: {},
    // 變更大類代號
    aplCatl: '',
    /** Email有效性驗證紀錄 */
    validEmailArray: [],
    // 從投資屬性問卷平台回來的要去的頁面
    fromIQRedirect: '',
    // 從投資屬性問卷平台回來的參數
    questNoIQ: '',
};

export const services = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
